import { match } from 'ts-pattern';
import { LineHeight } from './lineHeightToValue';
const BUTTON_GAP = 4;
const BUTTON_PAD_RIGHT = 4;

/**
 * Returns the total width (in px) of the action-button region inside a header cell.
 *
 * The region contains a sort button (always present) and optionally a menu button.
 * Button sizes depend on the grid's `headerHeight` setting:
 * - COMPACT / SHORT / DEFAULT → 24px (IconButton size="small")
 * - TALL / THUMBNAIL → 32px (IconButton size="default")
 *
 * Layout: [sortBtn] [gap] [menuBtn?] [padRight]
 *
 * Exported for unit testing. Used by `useColumnAutosize` to dynamically compute
 * the `headerButtonWidth` passed to `measureColumnContentWidth`.
 */
export function getHeaderButtonWidth(headerHeight: LineHeight, showMenu: boolean): number {
  const buttonSize = match(headerHeight).with('COMPACT', 'SHORT', 'DEFAULT', () => 24).with('TALL', 'THUMBNAIL', () => 32).exhaustive();
  if (showMenu) {
    return buttonSize + BUTTON_GAP + buttonSize + BUTTON_PAD_RIGHT;
  }
  return buttonSize + BUTTON_PAD_RIGHT;
}